import { useQuery } from '@tanstack/react-query';
import { enterpriseApiClient } from '../../client';
import { WorkOrdersApi } from '../../openapi';
import { useAllowedEventTypes } from '../../eventType';
import { filterWorkOrderDetails } from '../utils/filterWorkOrderDetails';
import type { WorkOrderDetailViewModel } from '../../openapi';
import { workOrderKeys } from '../constants';
import { CACHE_TIMINGS } from '@api/constants';

export const useWorkOrderDetails = (jobNumber: string, enabled = true) => {
  const workOrdersApi = new WorkOrdersApi(
    undefined,
    undefined,
    enterpriseApiClient
  );

  const { data: allowedEvents, isLoading: isLoadingEvents } =
    useAllowedEventTypes();

  return useQuery<WorkOrderDetailViewModel[], Error>({
    queryKey: workOrderKeys.details(jobNumber, allowedEvents),
    queryFn: async () => {
      const response = await workOrdersApi.apiWorkOrdersJobNumberDetailsGet({
        jobNumber
      });

      return filterWorkOrderDetails(response.data, allowedEvents || []);
    },
    enabled: enabled && !!jobNumber && !isLoadingEvents,
    refetchOnMount: true,
    refetchOnWindowFocus: true,
    ...CACHE_TIMINGS.WORK_ORDER
  });
};
